import { render, staticRenderFns } from "./BusinessOverview.vue?vue&type=template&id=22d2d562&"
import script from "./BusinessOverview.vue?vue&type=script&lang=js&"
export * from "./BusinessOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports